import { render, staticRenderFns } from "./UnverifiedKmnAlert.vue?vue&type=template&id=f405c126&scoped=true"
import script from "./UnverifiedKmnAlert.vue?vue&type=script&lang=js"
export * from "./UnverifiedKmnAlert.vue?vue&type=script&lang=js"
import style0 from "./UnverifiedKmnAlert.vue?vue&type=style&index=0&id=f405c126&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f405c126",
  null
  
)

export default component.exports